import { normalizePackagesMeta } from "./packagesMeta";
export function parseBootstrap(element) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const packagesRaw = (_a = element.dataset.packagesMeta) !== null && _a !== void 0 ? _a : "[]";
    let packagesMeta = [];
    try {
        packagesMeta = normalizePackagesMeta(JSON.parse(packagesRaw));
    }
    catch (_u) {
        packagesMeta = [];
    }
    return {
        version: (_b = element.dataset.version) !== null && _b !== void 0 ? _b : "",
        versionCodes: (_c = element.dataset.versionCodes) !== null && _c !== void 0 ? _c : "",
        code: (_d = element.dataset.code) !== null && _d !== void 0 ? _d : "",
        color: (_e = element.dataset.color) !== null && _e !== void 0 ? _e : "",
        leadBrand: (_f = element.dataset.leadBrand) !== null && _f !== void 0 ? _f : "",
        vin: (_g = element.dataset.vin) !== null && _g !== void 0 ? _g : "",
        userChange: (_h = element.dataset.userChange) !== null && _h !== void 0 ? _h : "",
        packagesMeta,
        financeType: (_j = element.dataset.financeType) !== null && _j !== void 0 ? _j : "",
        offerType: (_k = element.dataset.offerType) !== null && _k !== void 0 ? _k : "",
        defaultFinanceType: (_m = (_l = element.dataset.defaultFinanceType) !== null && _l !== void 0 ? _l : element.dataset.financeType) !== null && _m !== void 0 ? _m : "",
        defaultOfferType: (_p = (_o = element.dataset.defaultOfferType) !== null && _o !== void 0 ? _o : element.dataset.offerType) !== null && _p !== void 0 ? _p : "",
        contractPeriod: (_q = element.dataset.contractPeriod) !== null && _q !== void 0 ? _q : "",
        contribution: (_r = element.dataset.contribution) !== null && _r !== void 0 ? _r : "",
        repurchase: (_s = element.dataset.repurchase) !== null && _s !== void 0 ? _s : "",
        mileage: (_t = element.dataset.mileage) !== null && _t !== void 0 ? _t : "",
    };
}
